import WidgetModule from "@eisinc/Overrides/Widgets/Basic/Logo";

export * from "@eisinc/Overrides/Widgets/Basic/Logo";

export default WidgetModule;
